import { Box, Button } from "@mui/material";
import React from "react";
import { RefreshIcon, RepeatIcon } from "../../assets/constants";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";

const MobileAppActionButtons = ({
  resendCredentialsHandler,
  openChangePasswordModalHandler,
}) => {
  const resendClientCredentials = useSelector(
    (state) => state.resendClientCredentials
  );
  const { loading } = resendClientCredentials;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap="8px"
    >
      <LoadingButton
        startIcon={<RepeatIcon />}
        sx={{
          textTransform: "capitalize",
          borderColor: "#BFBFBF",
          color: "#212121",
          "&:hover": {
            borderColor: "#BFBFBF",
          },
        }}
        fullWidth
        variant="outlined"
        onClick={resendCredentialsHandler}
        loading={loading}
      >
        Reshare Credentials
      </LoadingButton>
      <Button
        startIcon={<RefreshIcon />}
        sx={{
          textTransform: "capitalize",
          borderColor: "#BFBFBF",
          color: "#212121",
          "&:hover": {
            borderColor: "#BFBFBF",
          },
        }}
        fullWidth
        variant="outlined"
        onClick={openChangePasswordModalHandler}
      >
        Change Password
      </Button>
    </Box>
  );
};

export default MobileAppActionButtons;
